import ApiService from "@/common/api/api.service";

export const SupplierService = {
        
    list() {
        ApiService.setHeader()
        return ApiService.get('supplier')
    },
    search(page=1, itemsPerPage=10, active=true, search="", orderBy = "", sortDesc = "") {
        ApiService.setHeader()
        return ApiService.get(`supplier?page=${page}&itemsPerPage=${itemsPerPage}&active=${active}&search=${search}&orderBy=${orderBy}&sortDesc=${sortDesc}`)
    },

    get(slug) {
        ApiService.setHeader()
        return ApiService.get('supplier', slug)
    },
    create(data) {
        ApiService.setHeader()
        return ApiService.post('supplier', data)
    },
    update(slug, data) {
        ApiService.setHeader()
        return ApiService.update('supplier', slug, data)
    },
    active(id) {
        ApiService.setHeader()
        return ApiService.update(`supplier/${id}/active`)
    },
    inactive(id) {
        ApiService.setHeader()
        return ApiService.update(`supplier/${id}/inactive`)
    },

    delete(id) {
        ApiService.setHeader()
        return ApiService.delete(`supplier/${id}`)
    }
}